import React from "react";
import LocatorMap from "./wms";

/**
 * WMS Map Viewer Page
 * Opens in a new tab with ticket location coordinates
 * Supports URL parameters: ?lat=43.7&lng=-79.4&radius=500
 */
const GSIMapViewer = () => {
  return (
    <div style={{ width: "100vw", height: "100vh", margin: 0, padding: 0 }}>
      <LocatorMap />
    </div>
  );
};

export default GSIMapViewer;
